import React from "react";
import { Dialog } from "../../../ui/Dialog";
import { Button } from "../../../ui/Button";

interface UnsavedChangesDialogProps {
  onDiscard: () => void;
  onCancel: () => void;
}

/**
 * Guards a draft criterion when the user navigates away mid-edit.
 *
 * Previously, typing a change and then clicking another evaluator in the list dropped the
 * draft silently — no guard, no prompt.
 */
export function UnsavedChangesDialog({
  onDiscard,
  onCancel,
}: UnsavedChangesDialogProps) {
  return (
    <Dialog
      title="Discard unsaved changes?"
      onClose={onCancel}
      maxWidth="max-w-md"
      maxHeight="max-h-[50vh]"
      ariaLabelledBy="unsaved-changes-title"
    >
      <div className="flex flex-col gap-4">
        <p className="text-sm text-muted-foreground">
          Your edits to this criterion haven&apos;t been saved. Leaving now discards them.
        </p>
        <div className="flex justify-end gap-2">
          <Button variant="outline" size="sm" onClick={onCancel}>
            Keep editing
          </Button>
          {/* Distinct from the editor's own "Discard changes", which stays put. */}
          <Button variant="danger" size="sm" onClick={onDiscard}>
            Discard and leave
          </Button>
        </div>
      </div>
    </Dialog>
  );
}
